export default "__VITE_ASSET__D5dNwlZV__"